var map = {
	"./sampang/Content.js": [
		2419,
		658,
		270,
		336
	],
	"./sampanganimation/Content.js": [
		4137,
		658,
		270,
		461,
		251,
		806,
		892,
		137
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7174;
module.exports = webpackAsyncContext;